import { Component, inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TitleActions } from '@app-shared/store/title/title.actions';
import { Store } from '@ngrx/store';

@Component({
  imports: [MatCardModule],
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
})
export class AccueilComponent implements OnInit {
  title = $localize`:@@PIECES-ACCUEIL:PIECES-ACCUEIL`;
  store = inject(Store);

  ngOnInit(): void {
    this.store.dispatch(TitleActions.updateTitle({ title: this.title }));
  }
}
